export default {"src":"/_next/static/media/ico_check2.d600fe1d.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};